<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <h4>Fotos del vehículo en general</h4>
      <div class="row">
        <!-- FRENTE -->
        <div v-if="isFieldVisible('photo_general_front_file')" class="col-md-4 mt-3">
          <div>
            <div class="form-group bordered">
              <label for="photo_general_front_file" class="form-label text-left">{{ getFieldDescription('photo_general_front_file') }}</label>
            </div>
              <div>
                <div>
                  <div @click="openCamera('photo_general_front_file')" class="btn btn-custom">
                    <i class="bi bi-camera-fill"></i> Tomar fotografía
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    capture="camera"
                    class="form-control inputfile"
                    :name="'photo_general_front_file'"
                    :id="'photo_general_front_file'"
                    style="display: none;"
                    @change="onFileChange('photo_general_front_file')"
                  />
                </div>
              </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_general_front_file" @click="openImageModal(photo_general_front_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- ATRAS -->
        <div v-if="isFieldVisible('photo_general_back_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_back_file" class="form-label text-left">{{ getFieldDescription('photo_general_back_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_back_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_back_file'"
                  :id="'photo_general_back_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_back_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_back_file" @click="openImageModal(photo_general_back_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- LATERAL IZQUIERDO -->
        <div v-if="isFieldVisible('photo_general_left_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_left_file" class="form-label text-left">{{ getFieldDescription('photo_general_left_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_left_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_left_file'"
                  :id="'photo_general_left_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_left_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_left_file" @click="openImageModal(photo_general_left_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- LATERAL DERECHO -->
        <div v-if="isFieldVisible('photo_general_right_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_right_file" class="form-label text-left">{{ getFieldDescription('photo_general_right_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_right_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_right_file'"
                  :id="'photo_general_right_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_right_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_right_file" @click="openImageModal(photo_general_right_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- INTERIOR PLAZA DELANTERA -->
        <div v-if="isFieldVisible('photo_general_interior_front_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_interior_front_file" class="form-label text-left">{{ getFieldDescription('photo_general_interior_front_file') }}</label>
          </div> 
            <div>
              <div>
                <div @click="openCamera('photo_general_interior_front_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_interior_front_file'"
                  :id="'photo_general_interior_front_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_interior_front_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_interior_front_file" @click="openImageModal(photo_general_interior_front_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- INTERIOR PLAZA TRASERA -->
        <div v-if="isFieldVisible('photo_general_interior_back_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_interior_back_file" class="form-label text-left">{{ getFieldDescription('photo_general_interior_back_file') }}</label>
          </div> 
            <div>
              <div>
                <div @click="openCamera('photo_general_interior_back_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_interior_back_file'"
                  :id="'photo_general_interior_back_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_interior_back_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_interior_back_file" @click="openImageModal(photo_general_interior_back_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO KM VEHICULO -->
        <!-- <div v-if="isFieldVisible('photo_general_vehicle_kms_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_vehicle_kms_file" class="form-label text-left">{{ getFieldDescription('photo_general_vehicle_kms_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_vehicle_kms_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_vehicle_kms_file'"
                  :id="'photo_general_vehicle_kms_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_vehicle_kms_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_vehicle_kms_file" @click="openImageModal(photo_general_vehicle_kms_file)">Ver Imagen</div>
          </div>
        </div> -->
        <!-- FOTO DEL N DE CHASIS DEL VEHICULO -->
        <div v-if="isFieldVisible('photo_general_vehicle_chassis_number_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_vehicle_chassis_number_file" class="form-label text-left">{{ getFieldDescription('photo_general_vehicle_chassis_number_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_vehicle_chassis_number_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_vehicle_chassis_number_file'"
                  :id="'photo_general_vehicle_chassis_number_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_vehicle_chassis_number_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_vehicle_chassis_number_file" @click="openImageModal(photo_general_vehicle_chassis_number_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO MOTOR -->
        <div v-if="isFieldVisible('photo_general_engine_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_engine_file" class="form-label text-left">{{ getFieldDescription('photo_general_engine_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_engine_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_engine_file'"
                  :id="'photo_general_engine_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_engine_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_engine_file" @click="openImageModal(photo_general_engine_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- FOTO INTERIOR BAUL -->
        <div v-if="isFieldVisible('photo_general_trunk_file')" class="col-md-4 mt-3">
          <div>
          <div class="form-group bordered">
            <label for="photo_general_trunk_file" class="form-label text-left">{{ getFieldDescription('photo_general_trunk_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_trunk_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_trunk_file'"
                  :id="'photo_general_trunk_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_trunk_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_trunk_file" @click="openImageModal(photo_general_trunk_file)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoGeneralCars'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils';  

export default {
  name: 'FormPhotoGeneralCars',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_general_front_file = ref(null);
    const photo_general_back_file = ref(null);
    const photo_general_left_file = ref(null);
    const photo_general_right_file = ref(null);
    const photo_general_interior_front_file = ref(null);
    const photo_general_interior_back_file = ref(null);
    //const photo_general_vehicle_kms_file = ref(null);
    const photo_general_vehicle_chassis_number_file = ref(null);
    const photo_general_engine_file = ref(null);
    const photo_general_trunk_file = ref(null);

    const formData = ref({
      photo_general_front_id: null,
      photo_general_back_id: null,
      photo_general_left_id: null,
      photo_general_right_id: null,
      photo_general_interior_front_id: null,
      photo_general_interior_back_id: null,
      photo_general_vehicle_kms_id: null,
      photo_general_vehicle_chassis_number_id: null,
      photo_general_engine_id: null,
      photo_general_trunk_id: null,
    });

    const cargarDatos = () => {
      try {
        const requiredFields = [
          'photo_general_front_file',
          'photo_general_back_file',
          'photo_general_left_file',
          'photo_general_right_file',
          'photo_general_interior_front_file',
          'photo_general_interior_back_file',
          //'photo_general_vehicle_kms_file',
          'photo_general_vehicle_chassis_number_file',
          'photo_general_engine_file',
          'photo_general_trunk_file'
        ];

        showComponentData.value = dataCompany.value && requiredFields.some(field => dataCompany.value[field]);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoGeneralCars').modal('show');
    };

    const openCamera = (fieldName) => {
      const inputElement = document.getElementById(fieldName);
      inputElement.click();
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_general_front_file: photo_general_front_file,
        photo_general_back_file: photo_general_back_file,
        photo_general_left_file: photo_general_left_file,
        photo_general_right_file: photo_general_right_file,
        photo_general_interior_front_file: photo_general_interior_front_file,
        photo_general_interior_back_file: photo_general_interior_back_file,
        //photo_general_vehicle_kms_file: photo_general_vehicle_kms_file,
        photo_general_vehicle_chassis_number_file: photo_general_vehicle_chassis_number_file,
        photo_general_engine_file: photo_general_engine_file,
        photo_general_trunk_file: photo_general_trunk_file,
      };
     
      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
    };

    const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };


    const emitFieldChanged = () => {
      const formFields = {
        photo_general_front_id: photo_general_front_file.value,
        photo_general_back_id: photo_general_back_file.value,
        photo_general_left_id: photo_general_left_file.value,
        photo_general_right_id: photo_general_right_file.value,
        photo_general_interior_front_id: photo_general_interior_front_file.value,
        photo_general_interior_back_id: photo_general_interior_back_file.value,
        //photo_general_vehicle_kms_id: photo_general_vehicle_kms_file.value,
        photo_general_vehicle_chassis_number_id: photo_general_vehicle_chassis_number_file.value,
        photo_general_engine_id: photo_general_engine_file.value,
        photo_general_trunk_id: photo_general_trunk_file.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_general_front_file,
      photo_general_back_file,
      photo_general_left_file,
      photo_general_right_file,
      photo_general_interior_front_file,
      photo_general_interior_back_file,
      //photo_general_vehicle_kms_file,
      photo_general_vehicle_chassis_number_file,
      photo_general_engine_file,
      photo_general_trunk_file,
      openCamera,
    };
  },
};
</script>

